import { Flex, VStack } from '@chakra-ui/react'
import { useState, useContext } from 'react'
import { useParams, useLocation } from 'react-router-dom'
import DocumentTable from '../../../components/tables/DocumentTable'
import DocumentStatisticsTable from '../../../components/tables/DocumentStatisticsTable'
import { AuthContext } from "../../../hooks/auth/useAuth";

interface DocumentPageProps {
  isUserPage?: boolean;
}

const DocumentPage: React.FC<DocumentPageProps> = ({ isUserPage = false }) => {
  const params = useParams()
  const location = useLocation()
  const isAdmin = location.pathname.includes('admin')
  const selectedTab = params?.type ?? (isUserPage ? 'hrinfo' : 'documents')

  const { user } = useContext(AuthContext);
  const employeeId = user?.id;

  const [isScrolled, setIsScrolled] = useState(false)

  const renderTable = () => {
    switch (selectedTab) {
      case 'documents':
        return isUserPage
          ? <DocumentTable docType="documents" recipient={employeeId} showAddButton={isAdmin} />
          : <DocumentTable docType="documents" showAddButton={isAdmin} />;
      case 'templates':
        return <DocumentTable docType="templates" showAddButton={true} />;
      case 'hrinfo':
        return <DocumentTable docType="hr" showAddButton={isAdmin} />;
      case 'statistics':
        return <DocumentStatisticsTable />
    }
  }

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    setIsScrolled(event.currentTarget.scrollTop > 0)
  }

  return (
    <Flex
      flexDirection={{ base: 'column', md: 'row' }}
      height="100%"
      overflowY="auto"
      onScroll={handleScroll}
      borderRadius={isScrolled ? '10px' : '0'}
      position="relative"
    >
      <VStack gap={{ base: '12px', md: '16px' }} width="100%" p={{ base: '12px', md: '16px' }}>
        {renderTable()}
      </VStack>
    </Flex>
  )
}

export default DocumentPage
